export default __webpack_public_path__ + "static/spiritual-christian-paul-4-6d4fcb520507bc7fe099b1d615922a40.jpg";